<template>
  <div class="step-form">
    <div class="step-form-section">
      <div class="inner-container">
        <div class="input-group">
          <label for="age">
            {{ $t("labels.age") }}
          </label>
          <numeric-input
            :config="ageInputConfig"
            :value="age"
            v-model.number="age"
            @decreaseValue="handleDecreaseAge"
            @increaseValue="handleIncreaseAge"
          />
        </div>
      </div>
      <div class="inner-container">
        <div class="input-group">
          <label for="height">
            {{ $t("labels.height") }}
          </label>
          <numeric-input
            :config="heightInputConfig"
            :value="height"
            v-model.number="height"
            @decreaseValue="handleDecreaseHeight"
            @increaseValue="handleIncreaseHeight"
          />
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="step-form-section" v-if="age >= 12">
        <div class="inner-container">
          <div class="form-group">
            <label for="age">
              {{ $t("labels.sex") }}
            </label>
            <div class="gender-wrapper">
              <div
                class="gender-tile"
                @click="setGender(genderEnum.MAN)"
                :class="{ selected: gender === genderEnum.MAN }"
              >
                <img src="@/assets/images/konfigurator_mezczyzna.svg" alt="Ikona mężczyzny" />
                <span>{{ $t("labels.man") }}</span>
              </div>
              <div
                class="gender-tile"
                @click="setGender(genderEnum.WOMAN)"
                :class="{ selected: gender === genderEnum.WOMAN }"
              >
                <img src="@/assets/images/konfigurator_kobieta.svg" alt="Ikona kobiety" />
                <span>{{ $t("labels.woman") }}</span>
              </div>
              <div
                class="gender-tile"
                @click="setGender(genderEnum.UNISEX)"
                :class="{ selected: gender === genderEnum.UNISEX }"
              >
                <img src="@/assets/images/konfigurator_unisex.svg" alt="Ikona unisex" />
                <span>{{ $t("labels.unisex") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

import "./StepForm.scss";

import { genderEnum } from "@/enums/genderEnum";
import setCookie from "@/utils/setCookie";
import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";
import NumericInput from "../App/NumericInput.vue";

export default {
  name: "FirstStepForm",
  data() {
    return {
      genderEnum,
      heightInputConfig: {
        min: 100,
        max: 240,
        step: 1,
        id: "height",
        placeHolder: "Wzrost",
        ref: "heightInputNumber",
      },
      ageInputConfig: {
        min: 1,
        max: 100,
        step: 1,
        id: "age",
        placeHolder: "Wiek",
        ref: "ageInputNumber",
      },
    };
  },
  computed: {
    ...mapFields(["filters.age", "filters.height", "filters.gender"]),
  },
  watch: {
    // watch every filter value change and save it in cookies and URL parameters
      age: function (newVal) {
      setCookie("age", +newVal, this);
      updateUrlParams();
      if (newVal < 12) {
        this.gender = null;
      }
    },
    height: function (newVal) {
      setCookie("height", +newVal, this);
      updateUrlParams();
    },
      gender: function (newVal) {
          setCookie("gender", newVal == null ? null : +newVal, this);
      updateUrlParams();
    },
  },
  methods: {
    handleDecreaseHeight: function (e) {
      this.height--;
    },
    handleIncreaseHeight: function (e) {
      this.height++;
    },
    handleDecreaseAge: function (e) {
      this.age--;
    },
    handleIncreaseAge: function (e) {
      this.age++;
    },
    setGender(param) {
      this.gender = param;
    },
    // used in mounted hook. Retrieves filters values from browser cookies
    getCookies() {
      const age = this.$cookies.get("age");
      if (age) this.age = +age;

      const height = this.$cookies.get("height");
      if (height) this.height = +height;

      const gender = this.$cookies.get("gender");
      if (gender != null) this.gender = +gender;
    },
  },
  mounted() {
    // set filters values depending on cookies
    this.getCookies();
  },
  components: {
    NumericInput,
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>
<style scoped>
.fade-enter-active {
  transition: 0.5s ease;
}

.fade-leave-active {
  transition: 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
